import styled from 'styled-components';

export default styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  margin-bottom: 12px;
  line-height: 36px;
`